module.exports = __webpack_public_path__ + "img/40_62.4f6b17df.png";